import { createRouter, createWebHistory } from "vue-router";
import { useLoginStore } from "@/store/loginStore";
import NotFound from "@/components/pages/NotFound.vue";
import adminRoutes from "./adminRoutes";
import authRoutes from "./authRoutes";
import userRoutes from "./userRoutes";
import { useSettingStore } from "@/store/adminStore";

const routes = [
  ...adminRoutes,
  ...authRoutes,
  ...userRoutes,
  { path: "/:pathMatch(.*)*", name: "NotFound", component: NotFound },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to, from, next) => {
  const loginStore = useLoginStore();
  const settingStore = useSettingStore();

  // بررسی انقضای توکن
  if (loginStore.isTokenExpired()) {
    localStorage.removeItem("token");
    localStorage.removeItem("admin");
    localStorage.removeItem("tokenExpiration");
    loginStore.isAuthenticated = false;
  }

  const isAuthenticated = loginStore.isAuthenticated;
  const isAdmin = loginStore.isAdmin;
  const isDriver = loginStore.isDriver;
  if (!isAuthenticated) {
    if (to.path !== "/" && to.path !== "/verification") {
      return next("/");
    }
  } else {
    if (to.meta.requiresAuthLevelTwo && !isAdmin ) {
      console.log("user1");
      return next("/userpanel");
      
    } else if (to.meta.requiresAuthLevelOnePlus && isAdmin) {
      console.log("admin");

      return next("/admin");
    } else if (to.meta.requiresAuthLevelOne && isDriver) {
      console.log("driverr");

      return next("/userpanel");
    } else if (to.meta.requiresGuest) {
      isAdmin ? next("/admin") : next("/userpanel");
      console.log("guest");

    }
  }

  next();
  try {
    await settingStore.getCompanyInfo(); // بارگذاری اطلاعات شرکت
    const companyName = settingStore.basicSiteInfos.companyName;
    const title = to.meta.title;

    // تنظیم عنوان صفحه
    document.title = title ? `${title} - ${companyName}` : companyName;
  } catch (error) {
    console.error("Error loading company info:", error);
    document.title = "خطا در بارگذاری اطلاعات";
  }
});

export default router;
